import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatQuestion',
  pure: true // Esto garantiza que solo se ejecute cuando cambie col o rowData
})
export class FormatQuestionPipe implements PipeTransform {
  transform(col: any, rowData: any): any[] {
    if (!col?.configField?.[0]) return [];
    
    // Solo se ejecutará cuando sea estrictamente necesario
    return [{
      ...col.configField[0],
      value: rowData ? rowData[col.field] : null
    }];
  }
}
